import classnames from 'classnames';
import Utils from 'Utils';
import React, { useState, useEffect, useRef, useMemo, useCallback, useLayoutEffect } from 'react';
import { Icon, Button, Typography, message, Spin, Modal, Table } from 'antd';
import useInstallState from 'useInstallState';
import { useWindowResize } from 'beautiful-react-hooks'

import extDisabled from 'extDisabled';
import getTT from 'getTT';
import styles from './style.scss?__local';

import extHandlers from './extHandlers'

import FeeInstallModal from './feeInstallModal'
import FeeChangeConfirm from './feeChangeConfirm'
import FeeInstallDataModel from 'feeInstall'
import InAppPurchase from './InAppPurchase/InAppPurchase';
import Like from '@cmps/Like/Like'
import * as R from 'ramda'
import GiftShareDetail from './GiftShareDetail'

const { Title, Paragraph, Text } = Typography;

const isNilOrEmpty = R.and(R.isNil, R.isEmpty)
const isScreenshotEmpty = R.pipe(R.prop('extMarketSnapshots'), isNilOrEmpty)
const isVideoEmpty = R.pipe(R.prop('extMarketVideoList'), isNilOrEmpty)
const isMediaEmpty = R.both(isScreenshotEmpty, isVideoEmpty)

function App({ data, install }) {
  // 1-未确认（该状态下需要弹窗） 2-已确认 3-不同意
  const [feeChangeConfirmStatus, setFeeChangeConfirmStatus] = useState(data.feeChangeConfirmStatus)

  const [containerWidth, setContainerWidth] = useState(0)
  const [scrollContentWidth, setScrollContentWitdh] = useState(0)
  const [isLeftMost, setLeftMost] = useState(true)
  const [isRightMost, setRightMost] = useState(true)

  const containerNode = useRef(null)

  const [scrollStart, setScrollStart] = useState(0)

  const calSize = () => {
    const scrollLeftPos = containerNode.current && containerNode.current.scrollLeft
    const cWidth = containerNode.current && containerNode.current.getBoundingClientRect().width
    const sWidth = containerNode.current && containerNode.current.scrollWidth

    // console.log('scrollLeftPos', scrollLeftPos)
    // console.log('containerWidth', cWidth)
    // console.log('scrollContentWidth', sWidth)

    setContainerWidth(cWidth)
    setScrollContentWitdh(sWidth)
    setLeftMost(scrollLeftPos <= 0)
    setRightMost(scrollLeftPos + cWidth >= sWidth)
  }


  useLayoutEffect(() => {
    setTimeout(() => {
      // console.log('========== useEffect')
      calSize()
      // console.log('========== end useEffect')
    }, 1000)
    setTimeout(() => {
      // console.log('========== useEffect')
      calSize()
      // console.log('========== end useEffect')
    }, 5000)
  }, [])

  useWindowResize(() => {
    // console.log('========== useWindowResize')
    calSize()
    // console.log('========== end useWindowResize')
  })

  const renderLivingList = () => {
    const { useProfileList } = data;
    /*
     * const useProfileList = R.repeat({
     *   roomId: 18220076,
     *   yyid: 909040639,
     *   nick: '1231',
     *   logo: 'https://huyaimg.msstatic.com/avatar/1025/8c/f88e521829580d91a4ac1a62849842_180_135.jpg?1553689903',
     * }, 20)
     */
    const handleClickAvatar = e => {
      e.stopPropagation();
      // e.preventDefault();
      // console.log('handleClickAvatar')
    }

    const MAX_STREAMER = 15

    if (!useProfileList || useProfileList.length <= 0) {
      return null
    }

    return (
      <>
        <div className={styles.living}>
          <span className={styles.label}>正在使用的直播间</span>
          <ul className={styles.list}>
            {
              useProfileList
                // .sort((left, right) => parseInt(right.audienceNum, 10) - parseInt(left.audienceNum, 10))
                .slice(0, MAX_STREAMER)
                .map(item => (
                  <li className={styles.item} key={item.yyid} onClick={handleClickAvatar} title={item.nick}>
                    <a href={Utils.getRoomUrl(item)} target="_blank" rel="noopener noreferrer">
                      <img src={item.logo} alt="" onError={Utils.avatarErrorHandler} />
                    </a>
                  </li>),
                )
            }
            {
              useProfileList.length < MAX_STREAMER
                ? null
                : (
                  <li className={styles['item--ellipsis']}>
                    <Icon type="ellipsis"></Icon>
                  </li>
                )
            }
          </ul>
        </div>
        <div className={styles['app-sec-line']}>
        </div>
      </>
    )
  }

  function handle(key) {
    const value = data[key]
    return handlers[key] ? handlers[key](value) : value
  }

  const extTypeDetailList = data.extTypes;
  const hasService = data.serviceFee && data.serviceFee.serviceFee && data.serviceFee.serviceFee.length > 0;

  const handlers = extHandlers(data);

  const scrollByPx = (px, smooth = true) => {
    // console.log('=========== scrollByPx')

    const scrollLeftPos = containerNode.current && containerNode.current.scrollLeft
    const newScrollLeftPos = scrollLeftPos + px
    const cWidth = containerNode.current && containerNode.current.getBoundingClientRect().width
    const sWidth = containerNode.current && containerNode.current.scrollWidth

    containerNode.current && containerNode.current.scrollTo({
      left: newScrollLeftPos,
      top: 0,
      behavior: smooth ? 'smooth' : 'auto',
    })

    // console.log('newPosition', newScrollLeftPos)
    // console.log('containerWidth', cWidth)
    // console.log('scrollContentWidth', sWidth)

    setLeftMost(newScrollLeftPos <= 0)
    setRightMost(newScrollLeftPos + cWidth >= sWidth)
    // console.log('=========== end scrollByPx')
  }

  const mediaNavi = (direction, event) => {
    event.stopPropagation()

    const factor = direction === 'left' ? -1 : 1

    scrollByPx(factor * containerWidth)
  }

  const handleMouseMove = ({ clientX, clientY }) => {
    if (scrollStart <= 0) return

    const delta = scrollStart - clientX

    // if (isRightMost && (delta <= 0)) return

    // if (isLeftMost && (delta >= 0)) return

    scrollByPx(delta, false)

    setScrollStart(clientX)
  }

  const handleMouseDown = ({ clientX, clientY }) => {
    setScrollStart(clientX)
    // console.log(clientX, clientY)
  }

  const handleMouseUp = () => {
  }

  const releaseMouse = () => {
    setScrollStart(-1)
  }

  // console.log('isMediaEmpty(data) ====>', isMediaEmpty(data));
  // console.log('isScreenshotEmpty', isScreenshotEmpty(data), 'isVideoEmpty:', isVideoEmpty(data));
  // console.log('extMarketSnapshots --->', 'R.isNil', R.isNil(data.extMarketSnapshots), 'R.isEmpty', R.isEmpty(data.extMarketSnapshots));
  // console.log('extMarketVideoList --->', 'R.isNil', R.isNil(data.extMarketVideoList), 'R.isEmpty', R.isEmpty(data.extMarketVideoList));

  return (
    <div className={classnames(styles.app, { [styles.disabled]: extDisabled(data) })}>
      <div className={styles['app-sec']}>
        {feeChangeConfirmStatus === 1 && (
          <FeeChangeConfirm
            data={data}
            onOk={() => setFeeChangeConfirmStatus(2)}
            onCancel={() => setFeeChangeConfirmStatus(3)}
            install={install}
          />
        )}
        <div className={styles['app-basic']}>
          <div className={styles.media}>
            <img src={handle('extLogo')} />
          </div>

          <div className={styles.product}>
            <div className={styles.name}>
              <div className={styles.text}>{handle('extName')}</div>
              {
                (data.extVersionType == 1 || data.extVersionType == 2 || data.extVersionType == 4 || Object.values(data.extTagInfos || {}).includes('小游戏')) ?
                  (
                    <div className={styles.labels}>
                      <span className={classnames(styles.label, { [styles.labelAccess]: data.extVersionType === 4 })}>
                        {data.extVersionType === 1 ? '开发' : null}
                        {data.extVersionType === 2 ? '测试' : null}
                        {data.extVersionType === 4 ? '审核通过' : null}
                        {Object.values(data.extTagInfos || {}).includes('小游戏') ? '小游戏' : null}
                      </span>
                      <span className={classnames(styles.label, { [styles.labelAccess]: data.extVersionType === 4 })}>
                        {data.extVersion}
                      </span>
                    </div>
                  ) :
                  null
              }
            </div>

            <div className={styles.author}>
              <b>作者：</b>
              <span><b>{handle('extAuthorName')}</b></span>
            </div>

            <div className={styles.brief}>{handle('extBrief')}</div>

            <div className={styles.category}>
              {
                (data.keywords || []).map(item => <span key={item}>{item}</span>)
              }
            </div>
          </div>

          <div className={styles.install}>
            <App.Install model={install} data={data} hasService={hasService} />

            <Like data={data} />
          </div>
        </div>
      </div>

      <div className={styles['app-sec-line']}>
      </div>

      {renderLivingList()}

      <GiftShareDetail extUuid={data.extUuid} />

      <InAppPurchase extUuid={data.extUuid} />

      {
        hasService &&
        <>
          <div className={styles['app-sec']}>
            <div className={styles['app-sec-tit']}>
              服务费说明
            </div>
            <Paragraph>
              服务费为主播在使用小程序时产生的费用，根据每月指标的梯度，收取一定费用支付给第三方开发者。
              每月服务费将在次月一号自动从主播虎牙币账户中扣除，扣除金额为对应最高梯度的费用。
              如果账户余额不足，将暂停使用该小程序的权限，可在小程序商店的账单中补缴。
            </Paragraph>
            <div className={styles['app-sf']}>
              {handle('serviceFee')}
            </div>
          </div>
        </>
      }

      <div className={styles['app-sec']}>
        <div className={styles['app-sec-tit']}>
          预览
        </div>
        {
          isMediaEmpty(data)
            ? null
            : (
              <div className={styles['app-screenshot-container']} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={releaseMouse} onMouseLeave={releaseMouse}>
                {
                  isLeftMost ? null : (
                    <div className={styles['navi-left']} onClick={event => mediaNavi('left', event)}>
                      <i className={styles['navi-arrow-left']}></i>
                    </div>
                  )
                }
                <div ref={containerNode} className={styles['app-screenshot-content']}>
                  {handle('extMarketVideoList')}
                  {handle('extMarketSnapshots')}
                </div>
                {
                  isRightMost ? null : (
                    <div className={styles['navi-right']} onClick={event => mediaNavi('right', event)}>
                      <i className={styles['navi-arrow-right']}></i>
                    </div>
                  )
                }
              </div>
            )
        }
      </div>

      <div className={styles['app-sec-line']}>
      </div>

      <div className={styles['app-sec']}>
        <div className={styles['app-sec-tit']}>
          介绍
        </div>
        <div className={styles['app-desc']}>
          {handle('extDescription')}
        </div>
      </div>

      <div className={styles['app-sec-line']}>
      </div>


      <div className={styles['app-sec']}>
        <div className={styles['app-sec-tit']}>
          其他信息
        </div>
        <div className={styles['app-info']}>
          {data.extVersion && <div><b>版本：</b>{data.extVersion}</div>}
          <div>
            <b>作者：</b>
            <span>{handle('extAuthorName')}</span>
          </div>
          {data.updateTime && <div><b>更新时间：</b>{Utils.formatDateTime(data.updateTime)}</div>}

          {data.extSupportEmail && <div><b>联系方式：</b>{data.extSupportEmail}</div>}

          <div className={styles.type}>
            <b>支持终端：</b>
            {
              extTypeDetailList.map(item => <span key={item.typeTag}>{item.typeName}</span>)
            }
          </div>
          {false && <div><b>服务条款：</b>{data.extVersionTerms}</div>}
          {false && <div><b>隐私条款：</b>{data.extVersionPrivacy}</div>}
        </div>
      </div>

    </div>
  )
}

App.Install = function ({ model, data, hasService }) {
  const [installState, setInstallState] = useInstallState(model)
  let [pending, setPending] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [hasBuy, setHasBuy] = useState(data.hadBuy);

  useEffect(() => () => {
    setPending = () => { }
  }, [])

  useEffect(() => {
    getTT(TT => {
      TT.getUserInfo(data => {
        if (data.uid != 0) {
          model
            .fetchRemoteState()
            .always(() => setPending(false))
        } else {
          setPending(false)
        }
      })
    })
  }, [])

  const installFee = data.installationFee;
  const isTestVer = data.extVersionOnline == 0;
  const extUuid = data.extUuid;

  const handleClick = () => {
    if (installState == 0) { // installState 为0为已安装，1为未安装
      Modal.confirm({
        title: `确定要移除“${data.extName}”么？`,
        content: '',
        okType: 'danger',
        onOk: toggle,
        autoFocusButton: null,
        cancelText: '取消',
        okText: '确定',
      })

      yaReportArr.push({
        eid: 'sys/click/appstore/extDetail/unstall',
        eid_desc: '小程序商店/详情页/卸载',
        prop: JSON.stringify({
          extId: extUuid,
        }),
      })
    } else {
      getTT(TT => TT.sudo(toggle))
    }

    const hadOtherTestVersionCode = 7; // 已经安装了非正式版小程序的状态码

    function toggle() {
      if (isTestVer || (!installFee && !hasService) || installState == 0) { // 非正式版本 或者 不是付费的类型 或者已安装 都按原有的方式安装
        setPending(true)

        model
          .toggle()
          .always(() => setPending(false))
          .fail((err, code) => {
            if (installState == 0) {
              message.error(`移除失败：${err}`);
            } else {
              if (code == hadOtherTestVersionCode) {
                Modal.confirm({
                  title: `您已安装过该小程序的其他开发或测试版本，是否要直接安装当前版本？`,
                  content: '',
                  onOk: model.forceInstall,
                  autoFocusButton: null,
                  cancelText: '取消',
                  okText: '确定',
                })
              } else {
                message.error(`添加失败：${err}`);
              }
            }
          })
      } else {
        if (hasBuy && installFee) {
          const feeInstallModel = new FeeInstallDataModel({ extUuid });

          feeInstallModel.on('error', err => {
            message.warn(err);

            setPending(false)
          })

          feeInstallModel.on('start', () => {
            setPending(true)
          })

          feeInstallModel.on('success', () => {
            setPending(false);
            setHasInstall();
          })
        } else {
          setShowModal(true)
        }
      }

      yaReportArr.push({
        eid: 'sys/click/appstore/extDetail/install',
        eid_desc: '小程序商店/详情页/安装',
        prop: JSON.stringify({
          extId: extUuid,
          isFree: !installFee && !hasService,
        }),
      })
    }
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const setHasInstall = () => {
    setHasBuy(true)

    setInstallState(0);
    model.setInstallState(0);

    closeModal();
  }

  return (
    <>
      {
        pending ?
          <App.Button.Loading /> :
          (
            installState == 0 ?
              <App.Button.Remove onClick={handleClick} /> :
              <App.Button.Add onClick={handleClick} installFee={installFee} hasService={hasService} />
          )
      }

      {
        showModal ?
          <FeeInstallModal
            data={data}
            hasBuy={hasBuy}
            hasService={hasService}
            closeModal={closeModal}
            setHasInstall={setHasInstall}
          ></FeeInstallModal>
          :
          ''
      }
    </>

  )
}

App.Button = {
  Add({ onClick = () => { }, installFee, hasService }) {
    const isFree = !installFee && !hasService;

    return (
      <>
        {
          isFree ?
            <span className={classnames(styles.button, styles.add)} onClick={onClick}>
              <Icon type="plus" />
              <span>添加</span>
            </span>
            :
            <>
              {
                installFee ?
                  <div className={styles.install_btn_wrapper} onClick={onClick}>
                    <p className={styles.install_fee_wrapper}>
                      <Icon type="account-book" style={{ fontSize: 20 }} />
                      <span className={styles.install_fee}>{installFee / 100}虎牙币</span>
                    </p>

                    {
                      hasService &&
                      <>
                        使用将收取额外的服务费
                      </>
                    }
                  </div>
                  :
                  <p className={styles.install_btn_wrapper} onClick={onClick}>
                    使用将收取额外的服务费
                  </p>
              }
            </>
        }
      </>
    )
  },
  Remove({ onClick = () => { }, text = '已添加' }) {
    return (
      <span className={classnames(styles.button, styles.remove)} onClick={onClick}>
        <span>{text}</span>
      </span>
    )
  },
  Loading() {
    return (
      <span className={classnames(styles.button, styles.loading)}>
        <Icon type="loading" />
      </span>
    )
  },
}

export default App;
